import React, { useState, useEffect, useRef } from "react";
import Config from "../../utils/config";
import Request from "../../utils/Request";
import CsvDown from "../../components/ExportFiles/CsvDown";
import Pagination from "../../components/common/Pagination";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TableWarpper, TabsDetailsWrapper, Text, ButtonSolid, IconView } from "../../components/styledConstants";
import { Heading } from "../../components/styledConstants";
import { Wrapper } from "./style";
import IconDate from "../../assets/images/IconDate";
import { getParams } from "../../utils/common";
import FilterBox from "../../components/common/FilterBox";
import { CSVLink, CSVDownload } from "react-csv";
import IconDownload from "../../assets/images/IconDownload";
import { dateConvertWithoutTime } from "../../utils/common";
import { FilterWrapper } from "../Merchants/style";
import { ConfirmModalWrapper } from "../../components/common/UI/ConfirmationModal/style";
import MaterialInput from "../../components/common/UI/MaterialInput";
import TableLoader from "../../components/common/TableLoader";
import CloseIcon from "@mui/icons-material/Close";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Options = [
    { value: "APPROVE", label: "APPROVE" },
    { value: "PENDING", label: "PENDING" },
    { value: "REJECTED", label: "REJECTED" },
]
const filterForm = [
    {
      name: "status",
      value: "",
      type: "select",
      placeholder: "Status",
      options: Options,
    },
    {
      name: "userName",        
      value: "",
      type: "text",
      placeholder: "Mobile Number",
      maxLength: 10,
    },
]
    
   
  


export default function EmailReports(){
    const paginationConfig = {
        currentPage: 1,
        pageSize: 10,
        totalPages: 1,
        numberOfElements: 0,
        totalElements: 0,
      };
      const {userType } = useParams();
      const [controls, setControls] = useState([...filterForm]);
      const [filterFormData, setFilterFormData] = useState({ status: "", userName: ""});
      const [expandedRow, setExpandedRow] = useState(null);
     const [userDetails, setUserDetails] = useState({});
     const [downloadPayload, setDownloadPayload] = useState({});
    const [emailList,setEmailList] = useState([]);
    const [loading, setLoading] = useState(true);
    const[showModal,setShowModal] = useState(false)
    const [selectedRow, setSelectedRow] = useState(null);
    const [remarks, setRemarks] = useState("");
    const [paginationData, setPaginationData] = useState({ ...paginationConfig });
    const [balanceDetails, setBalanceDetails] = useState(null);
    const headers = [
      { label: "Old Email", key: "oldEmail" },
      { label: "New Email", key: "newEmail" },
      { label: "Verification Date", key: "emailVerificationSentDate" },
      { label: "Status", key: "status" },
      { label: "Mobile Number", key: "userName" },
    ];
    const isgStatusColor = {
      SUCCESS: "color10",
      NOT_PRESENT: "color4",
      SKIPPED:"color4",
      PENDING:"color11",
      FAIL:"color11",
    } ;
    
    const setCurrentPage = (currentPage) => {
      console.log("currentPage",currentPage)
      // setPaginationData(prevPaginationData => ({
      //   ...prevPaginationData,
      //   currentPage: currentPage
       
      // }));
      setPaginationData({...paginationData,currentPage:currentPage})
    };
   const onFilterChange = (event, index) => {
     const _controls = [...controls];
     const currentControl = _controls[index];
   
     let value = event?.target ? event.target.value : event;
   
     // ✅ Apply number-only restriction for mobile (userName)
     if (currentControl.name === "userName") {
       const re = /^[0-9\b]+$/;
   
       if (value !== "" && !re.test(value)) return; // block invalid input
     }
   
     // Handle select vs text
     if (currentControl.type === "select") {
       currentControl.value = event;
     } else {
       currentControl.value = value;
     }
   
     setControls([..._controls]);
   };
      
    const refreshPage = () => {
  const resetControls = controls.map((item) => ({
    ...item,
    value: "",
  }));

  setControls(resetControls);

  const updatedPagination = {
    ...paginationConfig,
    currentPage: 1,
  };

  setPaginationData(updatedPagination);

  // ✅ Call API with fresh values (not state)
  getHoldBalenceReport(resetControls, updatedPagination);
};

    const getHoldBalenceReport = (customControls = controls, customPagination = paginationData) => {
  setLoading(true);

  const successHandler = (res) => {
    setLoading(false);
    setEmailList(res?.data?.content);

    let pagination = customPagination;
    pagination.totalPages = res?.data?.totalPages;
    pagination.numberOfElements = res?.data?.numberOfElements;
    pagination.totalElements = res?.data?.totalElements;

    setPaginationData({ ...pagination });

    const params = getParams(customControls);

    const payload = {
      status: params?.status.value,
      pagination: {
        pageNo: 1,
        pageSize: pagination.totalElements || 10000,
      },
    };
   if (params?.userName && params.userName.length === 10) {
    payload.userName = params.userName;
     }
    setDownloadPayload(payload);
  };

  const errorHandler = () => {};

  const api = new Request("", successHandler, errorHandler, false);

  const params = getParams(customControls);

  const tablePayload = {
  status: params?.status?.value,
  pagination: {
    pageNo: customPagination.currentPage,
    pageSize: 10,
  },
};

//  Only add userName if it exists and is 10 digits
if (params?.userName && params.userName.length === 10) {
  tablePayload.userName = params?.userName;
}

  return api.post(`${Config.apis.admin.APPROVE_EMAIL_REPORTS}`, tablePayload);
};
    
    

      useEffect(()=>{
        getHoldBalenceReport()
      },[paginationData?.currentPage])

    const handleAprove = (key) => {
  if (!selectedRow) return;

  const successHandler = (res) => {
    if (res?.message === "SUCCESS") {
      toast.success("SUCCESS");

      setShowModal(false);
      setRemarks("");
      setSelectedRow(null);
      getHoldBalenceReport();
    } else {
      toast.error(res?.msg || res?.message || "Something went wrong");
    }
  };

  const errorHandler = (err) => {
    //  Actual API failure (400, 500, etc.)
    const errorMsg =
      err?.response?.data?.msg ||
      err?.response?.data?.message ||
      "Something went wrong";

    toast.error(errorMsg);
  };

  const payload = {
    status: key,
    uuid: selectedRow?.id,
    userId: selectedRow?.userId,
    remarks: remarks,
  };

  const api = new Request("", successHandler, errorHandler, false);
  return api.post(`${Config.apis.admin.APPROVE_REJECT}`, payload);
};

     const onFilterSubmit = (e) => {
    e.preventDefault();
    getHoldBalenceReport();   // Just call API, no validation
};

     const handleView = (email) => {
        if (expandedRow === email.userId) {
          // If the row is already expanded, collapse it
          setExpandedRow(null);
          return;
        }
      
        const successHandler = (res) => {
          setUserDetails((prev) => ({
            ...prev,
            [email.userId]: res?.data,
          }));
          setExpandedRow(email.userId); // Expand the selected row
        };
      
        const errorHandler = () => {};
        const api = new Request("", successHandler, errorHandler, false);
        return api.get(`${Config.apis.user.FETCH_USER_DETAILS}/${email.userId}`);
      };
      
    
    return(
        <>
        <Wrapper className="">
        <div className="flex flex-center space-between mb10">
        <>
          <Heading size="xxl">Email-Reports</Heading>
        </>
        <div className="mr20">
            <CsvDown headers={headers} url={`${Config.apis.admin.APPROVE_EMAIL_REPORTS}`} params={downloadPayload} title="CSV"/>
          </div>
      </div>
            
        <TabsDetailsWrapper>
        <FilterWrapper>  <FilterBox 
          filterForm={controls} 
          onFilterChange={onFilterChange} 
          onFilterSubmit={onFilterSubmit}
          refreshPage={refreshPage}
          /></FilterWrapper>
        
       
      <TableWarpper className="mt50">
        <table className="table">
          <thead>
            <tr>
              <th className="text-left">
                <Text size="rg" fw="medium">
                Old Email
                  
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
              New Email
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                 Verification Date
                </Text>
              </th>
               <th className="text-left">
                <Text size="rg" fw="medium">
                 Mobile Number
                </Text>
              </th>
               <th className="text-left">
                <Text size="rg" fw="medium">
                 Remarks
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                Status
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                ISG Status
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                Action
                </Text>
              </th>
           

            
            </tr>
          </thead>
          <tbody>
          {loading ? <TableLoader /> : ""}
  {emailList?.length ? (
    emailList?.map((email, index) => (
      <React.Fragment key={index}>
        <tr>
          <td>{email?.oldEmail}</td>
          <td>{email?.newEmail}</td>
          <td>{email?.emailVerificationSentDate?.split("T")[0]+" "+ email?.emailVerificationSentDate?.split("T")[1]?.split(".")?.[0] || "-"}</td>
          <td>{email?.userName}</td>
          <td>{email?.remarks}</td>
          <td>
            {email?.status === "APPROVE" ? (
              <Text color="color10">{email?.status}</Text>
            ) : (
              <Text color="color11">{email?.status}</Text>
            )}
          </td>
          <td>
             <Text color={isgStatusColor[email?.isgStatus]}>
             {email?.isgStatus}
              </Text>
            </td>
          <td className="flex gap10 flex-center">
            {email?.status === "PENDING" ? (
              <ButtonSolid
                md
                onClick={() => {
                  setSelectedRow(email);
                  setShowModal(true);
                }}
              >
                Take Action
              </ButtonSolid>
            ) : (
              ""
            )}

            <p onClick={() => handleView(email)}>
              <IconView />
            </p>
          </td>
        </tr>

        {/* Conditionally render user details row */}
        {expandedRow === email.userId && (
          <tr>
            <td colSpan={5}>
              <div className="user-details">
                {userDetails[email.userId] ? (
                  <table className="table">
                   <thead>
            <tr>
              <th className="text-left">
                <Text size="rg" fw="medium">
                Name
                  
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
               Email
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                mobile
               
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                Address
                </Text>
              </th>
            
           

            
            </tr>
          </thead>



                    <tbody>
                        <tr>

                            <td>{`${userDetails[email.userId].firstName || ""} ${userDetails[email.userId].lastName || "" }`}</td>
                            <td>{userDetails[email.userId].email}</td>
                            <td>{userDetails[email.userId].mobile}</td>
                            <td>
      {userDetails[email.userId].address?.length ? (
        userDetails[email.userId].address.map((addr, idx) => (
          <div key={idx} className="address-block">
            <p><strong>Type:</strong> {addr.addressType}</p>
            <p><strong>State:</strong> {addr.state}</p>
            <p><strong>City:</strong> {addr.city}</p>
            <p><strong>Pincode:</strong> {addr.pinCode || "N/A"}</p>
            <p><strong>Address Line:</strong> {addr.address1.trim() || "N/A"}</p>
          </div>
        ))
      ) : (
        <p>No address available</p>
      )}
    </td>

                       
                        </tr>
                     
                    </tbody>
                  </table>
                ) : (
                  <p>Loading details...</p>
                )}
              </div>
            </td>
          </tr>
        )}
      </React.Fragment>
    ))
  ) : !loading ? (
    <tr>
      <td colSpan={12} style={{ textAlign: "center" }}>
        No record found
      </td>
    </tr>
  ) : (
    ""
  )}
</tbody>

        </table>
      </TableWarpper>

          <div className="mt24 flex flex-center">
          {paginationData.totalPages > 1 && (
          <Pagination
            totalPages={paginationData.totalPages}
            currentPage={paginationData.currentPage}
            getCurrentPageData={(curpage) => {
              setCurrentPage(curpage);
            }}
          />
        )}
          </div>
        </TabsDetailsWrapper>
     
     {showModal && (
  <div className="modal-overlay">
    <div className="modal-box">

      {/* Header */}
      <div className="flex space-between flex-center mb10">
        <Heading size="lg" color="color15">Add Remarks</Heading>

       <button
  onClick={() => {
    setShowModal(false);
    setRemarks("");
    setSelectedRow(null);
  }}
  style={{
    background: "none",
    border: "none",
    cursor: "pointer",
  }}
>
  <CloseIcon />
</button>
      </div>

      {/* Input */}
      <div className="mt20">
        <MaterialInput
          label="Remarks"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
      </div>

      {/* Actions */}
      <div className="flex space-between mt20">
        <ButtonSolid
          primary
          md
          onClick={() => handleAprove("REJECTED")}
        >
          Reject
        </ButtonSolid>
        <ButtonSolid
          success
          md
          onClick={() => handleAprove("APPROVE")}
        >
          Approve
        </ButtonSolid>

      </div>

    </div>
  </div>
)} 
<ToastContainer />
        </Wrapper>
    
        
        </>
    )
}
